export enum MessageStatusE {
  PENDING = 'pending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  READ = 'read',
}

export enum MessageTypeE {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  FILE = 'file',
  DOCUMENT = 'document',
  OFFICE = 'office',
  PDF = 'pdf',
  STICKER = 'sticker',
  CONTACT = 'contact',
  LOCATION = 'location',
  CONDITIONAL = 'conditional',
  NOTE = 'note',
  PRODUCT = 'product',
  ORDER = 'order',
  RESUME = 'resume',
  FEEDBACK = 'feedback',
  EMAIL = 'email',
  LINK = 'link',
  RECLAME_AQUI = 'reclame-aqui',
  IG_STORY = 'ig_story',
  IG_REEL = 'ig_reel',
  IG_COMMENT = 'ig_comment',
  CALL_PERMISSION_REQUEST = 'call-permission-request',
  UNSUPPORTED = 'unsupported',
}

export enum SenderTypeE {
  CONTACT = 'contact',
  AGENT = 'agent',
  FLOW = 'flow',
  BOT = 'bot',
  WORKFLOW = 'workflow',
  AI_AGENT = 'ai-agent',
}

export enum ForwardedMessage {
  MESSAGE = 'message',
  FORWARDED = 'forwarded',
}
